module.exports = __webpack_public_path__ + "img/rw.7b5cc7ab.svg";